import React from 'react'
import { Switch, Route } from 'react-router-dom';

import LiveTracking from '../pages/liveTracking';
import MyFleet from './assetView/MyFleet';
import EventView from '../pages/EventView';
import PlacesView from '../pages/PlacesView';
import TrackView from '../pages/TrackView';
import ReportView from '../pages/ReportView';
import SubAccountView from '../pages/SubAccountView';
import TripCenter from '../pages/TripCenter';
import GensetDashboard from './assetView/GensetDashboard';

const SecuredRoutes = () => {
    return (
        <Switch>
            <Route exact path="/secured/livetracking" component={LiveTracking} />
            <Route exact path="/secured/myfleet" component={MyFleet} />
            <Route exact path="/secured/tripcenter" component={TripCenter} />
            <Route exact path="/secured/eventview" component={EventView} />
            <Route exact path="/secured/placesview" component={PlacesView} />
            <Route exact path="/secured/trackview" component={TrackView} />
            <Route exact path="/secured/reportview" component={ReportView} />
            <Route exact path="/secured/subaccountview" component={SubAccountView} />
            <Route exact path="/secured/gensetdashboard" component={GensetDashboard} />
        </Switch>
    )
}

export default SecuredRoutes

//<Route exact path="/secured/billing/proformaInvoices/:proformaInvoiceNumber" component={BillDetailView} />